<template>
  <div v-if="articles.length" class="space-y-4 mb-6 content-visibility-latest-articles">
    <div class="flex items-center">
      <OIcon icon="note" svg-class="text-[#424242]" class="mr-2" />
      <div class="mr-2 font-medium text-24">{{ $t('news-page.latest-articles') }}</div>
      <div class="flex-grow border border-[#E2E5ED]"></div>
    </div>
    <LatestWidgetArticle v-for="(article, index) in articles" :key="article._id" :article="article" :index="index + 1" />
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import LatestWidgetArticle from './LatestWidgetArticle';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  props: {
    articles: {
      type: Array,
      required: true,
    },
  },
  components: { LatestWidgetArticle, OIcon },
  setup() {},
});
</script>
<style lang="scss">
.content-visibility-latest-articles {
  contain-intrinsic-size: 100px 346px;
  content-visibility: auto;
  @include sm() {
    content-visibility: visible;
  }
}
</style>
